import React from "react";
import ReactTextTransition from "react-text-transition";

const WobblyTextTransition = (props) => {
  return (
    <ReactTextTransition
      text={props.value}
      springConfig={{ tension: props.tension ? props.tension : 1000, friction: props.friction ? props.friction : 5}}
      inline
    />
  );
}

export default WobblyTextTransition;